import React, { useEffect, useState } from 'react';
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable';

const PunchPivotINOUT = () => {
  const empcode = localStorage.getItem('empcode');
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const { setLoading } = useLoading();

  // 🔹 Toggles for filters & table
  const [showFilters, setShowFilters] = useState(true);
  const [showTable, setShowTable] = useState(true);

  const [filters, setFilters] = useState({
    CompanyName: '',
    PlantName: '',
    VenderName: '',
    DepartmentName: '',
    EmployeeCode: '',
    EmployeeName: '',
    DOJStart: '',
    DOJEnd: ''
  });

  const [departments, setDepartments] = useState([]);
  const [plant, setPlant] = useState([]);
  const [company, setCompany] = useState([]);
  const [vender, setVender] = useState([]);

  useEffect(() => {
    loadDropdowns();
  }, []);

  const loadDropdowns = async () => {
    try {
      const [deptRes, plantRes, companyRes, venderRes] = await Promise.all([
        EmployeeProcessService.getDepartment(empcode),
        EmployeeProcessService.getPlant(empcode),
        EmployeeProcessService.getCompany('User'),
        EmployeeProcessService.getVender('User')
      ]);
      if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
      if (plantRes?.data?.statusCode === 200) setPlant(plantRes.data.result);
      if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
      if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
    } catch (error) {
      console.error("Error loading dropdowns:", error);
    }
  };

  const handlePlantChange = async (e) => {
    const plantId = e.target.value;
    setFilters(prev => ({ ...prev, PlantName: plantId, DepartmentName: "" }));
    setDepartments([]);

    if (!plantId) return;

    try {
      const res = await EmployeeProcessService.getDepartment(empcode, plantId);
      if (res?.data?.statusCode === 200) {
        setDepartments(res.data.result);
      } else {
        setDepartments([]);
      }
    } catch (error) {
      console.error("Error loading departments:", error);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await EmployeeProcessService.getPivotInOutReport(filters);
      if (response.data.statusCode === 200 && response.data.rows.length > 0) {
        setData(response.data.rows);
        setColumns(response.data.columns);
      } else {
        setData([]);
        setColumns([]);
        toast.info("No record found");
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    if (filters.CompanyName === "") {
      alert("Please select Company.");
      return;
    }
    // if (filters.PlantName === "") {
    //   alert("Please select Plant.");
    //   return;
    // }
    if (!filters.DOJStart || !filters.DOJEnd) {
      alert("Please select Start date and End date.");
      return;
    }
    if (filters.DOJStart > filters.DOJEnd) {
      alert("Start date cannot be after End date.");
      return;
    }
    fetchData();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PunchINOUT");
    XLSX.writeFile(workbook, "PunchINOUT.xlsx");
  };

  return (
    <div className="container mt-3">
      {/* 🔹 Heading Section */}
      <div className="mb-2 p-2 bg-light rounded">
        <h6 className="m-0 text-primary">Punch Pivot IN/OUT Report</h6>
      </div>

      {/* 🔹 Filters Section Toggle */}
      <div
        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-secondary bg-opacity-10 rounded"
        style={{ cursor: "pointer" }}
        onClick={() => setShowFilters(!showFilters)}
      >
        <h6 className="m-0">Filters</h6>
        <span style={{ fontSize: "12px" }}>{showFilters ? "▲" : "▼"}</span>
      </div>

      {showFilters && (
        <div className="row filter-section mb-3">
          <div className="col-md-3">
            <label className="text-primary">Select Company</label>
            <select name="CompanyName" value={filters.CompanyName} onChange={handleChange} className="form-select filter-input">
              <option value="">Select Company</option>
              {company.map(comp => (
                <option key={comp.id} value={comp.id}>{comp.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="text-primary">Select Plant</label>
            <select name="PlantName" value={filters.PlantName} onChange={handlePlantChange} className="form-select filter-input">
              <option value="">Select Plant</option>
              {plant.map(plan => (
                <option key={plan.id} value={plan.id}>{plan.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="text-primary">Select Vendor</label>
            <select name="VenderName" value={filters.VenderName} onChange={handleChange} className="form-select filter-input">
              <option value="">Select Vendor</option>
              {vender.map(ven => (
                <option key={ven.id} value={ven.id}>{ven.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="text-primary">Select Department</label>
            <select name="DepartmentName" value={filters.DepartmentName} onChange={handleChange} className="form-select filter-input">
              <option value="">Select Department</option>
              {departments.map(dept => (
                <option key={dept.id} value={dept.id}>{dept.name}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-2">
            <label className="text-primary">From</label>
            <input type="date" name="DOJStart" value={filters.DOJStart} onChange={handleChange} className="form-control filter-input" />
          </div>

          <div className="col-md-3 mt-2">
            <label className="text-primary">To</label>
            <input type="date" name="DOJEnd" value={filters.DOJEnd} onChange={handleChange} className="form-control filter-input" />
          </div>

          <div className="col-md-3 mt-2">
            <label className="text-primary">Employee Code</label>
            <input name="EmployeeCode" value={filters.EmployeeCode} onChange={handleChange} className="form-control filter-input" />
          </div>

          <div className="col-md-3 mt-2">
            <label className="text-primary">Employee Name</label>
            <input name="EmployeeName" value={filters.EmployeeName} onChange={handleChange} className="form-control filter-input" />
          </div>

          <div className="col-12 mt-3 d-flex gap-2">
            <button className="btn btn-primary" onClick={applyFilters}>Search</button>
            {data.length > 0 && (
              <button className="btn btn-success" onClick={downloadExcel}>Download Excel</button>
            )}
          </div>
        </div>
      )}

      {/* 🔹 Data Section Toggle */}
      <div
        className="d-flex justify-content-between align-items-center mb-2 p-2 bg-secondary bg-opacity-10 rounded"
        style={{ cursor: "pointer" }}
        onClick={() => setShowTable(!showTable)}
      >
        <h6 className="m-0">Data</h6>
        <span style={{ fontSize: "12px" }}>{showTable ? "▲" : "▼"}</span>
      </div>

      {showTable && (
        <div className="table-responsive">
          <CustomDataTable data={data} title="Employee List" />
        </div>
      )}
    </div>
  );
};

export default PunchPivotINOUT;
